import React from 'react';
import { List as AccCompaniesList } from '../../accounting/companies';
import { List as AccAccountTypesList } from '../../accounting/account-types';
import { List as AccOperationalTypesList } from '../../accounting/operational-types';
import { List as AccDocumentTypesList } from '../../accounting/document-types';
import { List as AccPeriodsList } from '../../accounting/periods';
import { StatementLines } from '../../accounting/statement-lines';
import {
  ReferenceCategoryWorkspace,
  type ReferenceNavItem,
} from './ReferenceCategoryWorkspace';

const BASE = '/parameters/finance';

const ITEMS: ReferenceNavItem[] = [
  {
    id: 'companies',
    label: 'Companies',
    description: 'Accounting companies / legal entities',
    permissionModuleKey: 'acc_companies',
  },
  {
    id: 'account-types',
    label: 'Account types',
    description: 'Chart of accounts categories',
    permissionModuleKey: 'acc_account_types',
  },
  {
    id: 'operational-types',
    label: 'Operational types',
    description: 'Ops classification for postings',
    permissionModuleKey: 'acc_operational_types',
  },
  {
    id: 'journal-types',
    label: 'Journal types',
    description: 'Document / journal type codes',
    permissionModuleKey: 'acc_document_types',
  },
  {
    id: 'statement-lines',
    label: 'Statement lines',
    description: 'Financial statement line mapping',
    fillHeight: true,
    permissionModuleKey: 'acc_accounts',
  },
  {
    id: 'periods',
    label: 'Periods',
    description: 'Accounting periods & close status',
    permissionModuleKey: 'acc_periods',
  },
];

function renderPanel(section: string) {
  switch (section) {
    case 'companies':
      return <AccCompaniesList />;
    case 'account-types':
      return <AccAccountTypesList />;
    case 'operational-types':
      return <AccOperationalTypesList />;
    case 'journal-types':
      return <AccDocumentTypesList />;
    case 'statement-lines':
      return <StatementLines />;
    case 'periods':
      return <AccPeriodsList />;
    default:
      return null;
  }
}

const FinanceReferenceWorkspace: React.FC = () => (
  <ReferenceCategoryWorkspace
    basePath={BASE}
    eyebrow="Finance"
    items={ITEMS}
    defaultSection="companies"
    renderPanel={renderPanel}
  />
);

export default FinanceReferenceWorkspace;
